import leftpad from 'left-pad';

// eslint-disable-next-line @typescript-eslint/no-var-requires
var REGEX_FORMAT = /\[([^\]]+)]|Y{2,4}|O|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
function getTimeProvider(_a) {
    var request = _a.request;
    var offset = 0;
    var inited = false;
    var init = function () {
        if (inited) {
            return Promise.resolve(now());
        }
        return request('https://api.qiandaoapp.com/now').then(function (_a) {
            var data = _a.data;
            var serverNow = data.timestamp * 1000;
            var localNow = Date.now();
            var diff = serverNow > localNow ? serverNow - localNow : localNow - serverNow;
            inited = true;
            if (diff < 30 * 1000) {
                return localNow;
            }
            else {
                offset = serverNow - localNow;
                return serverNow;
            }
        });
    };
    var now = function () {
        if (!inited) {
            throw new Error('必须在调用 `now` 之前初始化');
        }
        return Date.now() + offset;
    };
    return {
        init: init,
        now: now,
    };
}
var getOriginOffset = function (_a) {
    var _b = _a.sourceTime, sourceTime = _b === void 0 ? Date.now() : _b, _c = _a.compareTime, compareTime = _c === void 0 ? Date.now() : _c;
    if (sourceTime instanceof Date)
        sourceTime = sourceTime.valueOf();
    if (compareTime instanceof Date)
        compareTime = compareTime.valueOf();
    var offset = compareTime - sourceTime;
    var absOffset = Math.abs(offset);
    var oneDayMs = 864e5; // 24 * 60 * 60 * 1000
    var oneHourMs = 36e5; // 60 * 60 * 1000
    var days = 0;
    var hours = 0;
    var minutes = 0;
    days = Math.floor(absOffset / oneDayMs);
    absOffset -= days * oneDayMs;
    hours = Math.floor(absOffset / oneHourMs);
    absOffset -= hours * oneHourMs;
    minutes = Math.floor(absOffset / 6e4);
    absOffset -= minutes * 6e4;
    var seconds = Math.floor(absOffset / 1000);
    return { days: days, hours: hours, minutes: minutes, seconds: seconds, offset: offset };
};
var offset = function (_a) {
    var _b = _a.format, format = _b === void 0 ? 'DD天 HH小时mm分钟ss秒 O' : _b, _c = _a.sourceTime, sourceTime = _c === void 0 ? Date.now() : _c, _d = _a.compareTime, compareTime = _d === void 0 ? Date.now() : _d, _e = _a.beforeText, beforeText = _e === void 0 ? '前' : _e, _f = _a.afterText, afterText = _f === void 0 ? '后' : _f;
    var _g = getOriginOffset({
        sourceTime: sourceTime,
        compareTime: compareTime,
    }), days = _g.days, minutes = _g.minutes, hours = _g.hours, seconds = _g.seconds, offset = _g.offset;
    var offsetText = offset > 0 ? beforeText : afterText;
    if (/D/.test(format)) {
        if (days <= 0)
            format = format.replace(/D[^Hms]*/g, '');
    }
    else if (days > 0) {
        hours += days * 24;
        days = 0;
    }
    if (/H/.test(format)) {
        if (hours <= 0 && days <= 0)
            format = format.replace(/H[^Dms]*/g, '');
    }
    else if (hours > 0) {
        minutes += hours * 60;
        hours = 0;
    }
    if (/m/.test(format)) {
        if (minutes <= 0 && hours <= 0 && days <= 0)
            format = format.replace(/m[^DHs]*/g, '');
    }
    else if (minutes > 0) {
        seconds += minutes * 60;
        minutes = 0;
    }
    var matches = {
        D: days,
        DD: leftpad(days, 2, 0),
        H: hours,
        HH: leftpad(hours, 2, 0),
        m: minutes,
        mm: leftpad(minutes, 2, 0),
        s: seconds,
        ss: leftpad(seconds, 2, 0),
        O: offsetText,
    };
    return format.replace(REGEX_FORMAT, function (match, $1) { return $1 || matches[match]; });
};
var time = {
    offset: offset,
    getOriginOffset: getOriginOffset,
    getTimeProvider: getTimeProvider,
};

export { time as default };
